import { RenderFields } from "digimaker-ui";
import { FetchWithAuth } from "digimaker-ui/util";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

export const Add = (props: { id: number }) => {
  const [list, setList] = useState([]);

  const schoolID = props.id;

  const [data, setData] = useState({});
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const dataObject = {};
    for (let key of Array.from(form.keys())) {
      dataObject[key] = form.get(key);
    }

    dataObject["school_id"] = schoolID;

    if (!schoolID) {
      window.alert("Need school id");
      return;
    }

    FetchWithAuth("content/create/image/507", {
      method: "POST",
      body: JSON.stringify(dataObject),
    }).then((data) => {
      if (data.error === false) {
        console.log("Success");
        window.history.back();
      } else {
        window.alert(data.data.message);
      }
    });

    return false;
  };

  return (
    <div className="container">
      <div>
        <h2 className="h2">Add school image</h2>
      </div>

      <div style={{ fontWeight: "bold" }}>
        {(list.find((item: any) => item.id === schoolID) as any)?.name}
      </div>

      <form onSubmit={(e) => handleSubmit(e)}>
        Name: <span style={{ color: "red" }}>*</span>
        <input className="form-control" name="name" type="text" />
        <div key={schoolID}>
          <RenderFields
            mode="edit"
            type={"school_image"}
            data={data}
            validation={null}
          />
        </div>
        <div>
          <br />
          <Button type="submit" size="sm">
            Submit
          </Button>{" "}
          &nbsp;
          <Button
            size="sm"
            variant="light"
            onClick={() => window.history.back()}
          >
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
};
